import { useCallback, useMemo, useState } from "react";

import { PAYROLL_ADJUSTMENT_TYPES } from "../constants/constants";

const INITIAL_STATE = {
  open: false,
  type: null,
  applicantIds: [],
};

const useEventPayrollManualAdjustment = ({ records, lang }) => {
  const [state, setState] = useState(INITIAL_STATE);

  const close = useCallback(() => {
    setState((current) => ({ ...current, open: false }));
  }, []);

  const openAdjustment = useCallback((type, applicantIds) => {
    const normalizedIds = Array.from(
      new Set(
        (applicantIds || []).filter(
          (id) => id !== null && id !== undefined && id !== "",
        ),
      ),
    );

    if (!normalizedIds.length) return;

    setState({
      open: true,
      type,
      applicantIds: normalizedIds,
    });
  }, []);

  const openReward = useCallback(
    (applicantIds) =>
      openAdjustment(PAYROLL_ADJUSTMENT_TYPES.reward, applicantIds),
    [openAdjustment],
  );

  const openDeduction = useCallback(
    (applicantIds) =>
      openAdjustment(PAYROLL_ADJUSTMENT_TYPES.deduction, applicantIds),
    [openAdjustment],
  );

  const workerName = useMemo(() => {
    if (state.applicantIds.length !== 1) return null;

    const record = (records || []).find(
      (row) => String(row.id) === String(state.applicantIds[0]),
    );
    if (!record) return null;

    return lang === "ar" ? record.nameAr || record.name : record.name;
  }, [lang, records, state.applicantIds]);

  return {
    open: state.open,
    type: state.type,
    applicantIds: state.applicantIds,
    workerName,
    openReward,
    openDeduction,
    close,
  };
};

export default useEventPayrollManualAdjustment;
